import PropTypes from 'prop-types';
import React from 'react';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';

import QIllustration from 'components/QIllustration';

const VerifyEmailSentForIdentityVerification = ({ sendVerifyEmail }) => {
  const theme = useTheme();

  return (
    <Box
      textAlign='center'
      pl={8}
      pr={8}
      pt={5}
      pb={5}
      display='flex'
      flexDirection='column'
      alignItems='center'
      justifyContent='center'
    >
      <QIllustration name='emailVerificationSuccess' size='xl' />
      <br />
      <Typography variant='headlineRegular'>Click the verify button in your email to continue.</Typography>
      <br />
      <Typography color='textSecondary' variant='paragraphRegular'>
        {'If you don’t see the email soon, check your spam folder, or '}
        <Typography
          component='span'
          onClick={sendVerifyEmail}
          sx={{ color: theme.palette.primary.main, cursor: 'pointer' }}
          variant='inherit'
        >
          try resending it.&nbsp;
        </Typography>
        {'Once verified, we’ll move on to the next step automatically.'}
      </Typography>
    </Box>
  );
};
VerifyEmailSentForIdentityVerification.propTypes = {
  sendVerifyEmail: PropTypes.func,
};

export default VerifyEmailSentForIdentityVerification;
